module.exports = __webpack_public_path__ + "static/6-8bf6914e58141b04b5588f30e3f0c470.jpg";